/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import FileSaver from 'file-saver';
import { toast } from 'react-hot-toast';
import { Form } from '@unform/web';
import { format, getMonth, startOfDay, endOfDay } from 'date-fns';
import * as Yup from 'yup';
import { FiArrowDown } from 'react-icons/fi';
import { MdEdit } from 'react-icons/md';
import { FaCheck, FaQuestionCircle } from 'react-icons/fa';
import { RiArrowLeftRightLine } from 'react-icons/ri';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from 'reactstrap';
import ReactSelect from 'react-select';
import {
  Button,
  DownloadButton,
  InformationDiv,
  FullCalendar,
} from 'ui-kit-takeat';
import {
  Select as NewSelect,
  IconPencilFilled,
  IconTrash,
  Button as NewButton,
  IconEyeFilled,
  IconTrashFilled,
} from 'takeat-design-system-ui-kit';
import ReactInputMask from 'react-input-mask';
import CheckboxGroup from 'react-checkbox-group/lib/CheckboxGroup';
import NFeInfo from '~/services/NFeInfo';

import Input from '~/components/Form/Input';
import Select from '~/components/Form/SelectInput';
import CheckboxInput from '~/components/Form/Checkbox';
import InputCurrency from '~/components/Form/InputCurrency';

import formatCompleteDate from '~/services/formatCompleteDate';
import getValidationErrors from '~/services/getValidationErrors';
import api from '~/services/api';
import { LuRefreshCcw } from 'react-icons/lu';
import { generateSpecificInputsReportSheetXLSX } from '../../../services/generateSpecificInputSheet';
import {
  Container,
  HistoryTable,
  Actions,
  Delete,
  InputAreaStyled,
  StyledTooltip,
  StyledSelect,
} from './styles';

const InputRow = React.memo(function InputRow({
  input,
  handleDelete,
  categories,
  filterString,
  banks,
  suppliers,
  getBanks,
  getSuppliers,
  isInventory,
  inventory,
  setInventory,
  getInputs,
  inputsFiltered,
  setInputsFiltered,
  paymentMethods,
  user,
}) {
  const formRefBank = useRef(null);
  const formRefSupplier = useRef(null);

  // orderDate vai ser usado para ordernar o horario no modal de historico
  // true vai ser horario mais recente primeiro
  const [orderDate, setOrderDate] = useState(true);
  const [selectCategory, setSelectCategory] = useState();
  const [selectCategoryDefault, setSelectCategoryDefault] = useState();
  useEffect(() => {
    const categoryFiltered = categories?.find(
      (item) => item.value === input?.cash_flow_category_subcategory_id
    );

    if (categoryFiltered) {
      setSelectCategory({
        value: categoryFiltered.value,
        label: categoryFiltered.label,
      });

      setSelectCategoryDefault({
        value: categoryFiltered.value,
        label: categoryFiltered.label,
      });
    }
  }, [categories, input?.cash_flow_category_subcategory_id]);

  const months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ];

  const cfop_options = [
    { value: 1101, label: '1101 - Industrialização' },
    { value: 1556, label: '1556 - Uso e consumo' },
    { value: 1403, label: '1403 - Revenda' },
    { value: 1102, label: '1102 - Revenda' },
    {
      value: 1201,
      label: '1201 - Devolução de venda de produção do estabelecimento',
    },
    {
      value: 1202,
      label:
        '1202 - Devolução de venda de mercadoria adquirida ou recebida de terceiros',
    },
    { value: 1908, label: '1908 - Bem por conta de contrato de comodato' },
    { value: 1910, label: '1910 - Entrada de bonificação, doação ou brinde' },
    {
      value: 1949,
      label:
        '1949 - Outra entrada de mercadoria ou prestação de serviço não especificada',
    },
    {
      value: 1551,
      label: '1551 - Compra de ativo imobilizado dentro do estado',
    },
    { value: 2551, label: '2551 - Compra de ativo imobilizado fora do estado' },
    {
      value: 1407,
      label:
        '1407 - Compra de mercadoria para uso ou consumo cuja mercadoria está sujeita ao regime de substituição tributária',
    },
    { value: 2101, label: '2101 - Industrilização originado de outro estado' },
    { value: 2102, label: '2102 - Revenda originado de outro estado' },
    {
      value: 2403,
      label:
        '2403 - Compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária',
    },
    { value: 5202, label: '5202 - Devolução de compra para comercialização' },
    {
      value: 5929,
      label:
        '5929 - Lançamento efetuado em decorrência de emissão de documento fiscal relativo a operação ou prestação também registrada em equipamento Emissor de Cupom Fiscal - ECF',
    },
    {
      value: 1651,
      label:
        '1651 - Compra de combustível ou lubrificante para industrialização subsequente',
    },
    {
      value: 1407,
      label:
        '1407 - Compra de mercadoria para uso ou consumo cuja mercadoria está sujeita ao regime de substituição tributária',
    },
    {
      value: 1556,
      label: '1556 - Compra de material para uso ou consumo',
    },
    {
      value: 1401,
      label:
        '1401 - Compra para industrialização em operação com mercadoria sujeita ao regime de substituição tributária',
    },
    {
      value: 1653,
      label:
        '1653 - Compra de combustível ou lubrificante por consumidor ou usuário final',
    },
    {
      value: 5909,
      label: '5909 - Retorno de bem recebido por conta de contrato de comodato',
    },
    {
      value: 6108,
      label:
        '6108 - Venda de mercadoria adquirida ou recebida de terceiros, destinada a não contribuinte',
    },
    {
      value: 1411,
      label:
        '1411 - Devolução de venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita ao regime de substituição tributária',
    },
    {
      value: 1909,
      label: '1909 - Retorno de bem remetido por conta de contrato de comodato',
    },
    {
      value: 2556,
      label:
        '2556 - Classificam-se neste código as compras de produtos destinadas ao uso ou consumo do estabelecimento',
    },
    {
      value: 1653,
      label:
        '1653 - Compra de combustível ou lubrificante por consumidor ou usuário final',
    },
    {
      value: 2910,
      label: '2910 - Entrada de bonificação, doação ou brinde',
    },
    {
      value: 2406,
      label:
        '2406 - Compra de bem para o ativo imobilizado cuja mercadoria está sujeita ao regime de substituição tributária',
    },
    {
      value: 1902,
      label:
        '1902 - Retorno de mercadoria remetida para industrialização por encomenda',
    },
    {
      value: 1124,
      label: '1124 - Industrialização efetuada por outra empresa',
    },
    {
      value: 1152,
      label: '1152 - Transferência para comercialização',
    },
    {
      value: 1113,
      label:
        '1113 -  Entrada, proveniente de dentro do estado, de mercadoria recebida para ser utilizada no processo de industrialização por encomenda.',
    },
    {
      value: 2113,
      label:
        '2113 - Entrada, proveniente de outra unidade da Federação, de mercadoria recebida para ser utilizada no processo de industrialização por encomenda.',
    },
  ];

  const icms_origem_options = NFeInfo.icms_origem.map((icms) => ({
    value: icms.value,
    label: icms.description,
  }));
  const [selectedCfop, setSelectedCfop] = useState(() => handleCfopOption());
  const [selectedCst, setSelectedCst] = useState(() => handleCstOption());
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setTotalToSend(0);
    setInputZero(0);
    setModal(!modal);
  };
  const [rangeStartDate, setRangeStartDate] = useState({
    start: startOfDay(new Date()),
    end: endOfDay(new Date()),
  });

  const [modalEye, setModalEye] = useState(false);
  const [defaultCategory, setDefaultCategory] = useState();
  const [enableButton, setEnableButton] = useState(true);
  const [costCenterChange, setCostCenterChange] = useState(true);
  const [modalUnit, setModalUnit] = useState(false);
  const toggleUnit = () => setModalUnit(!modalUnit);

  const [newUnitaryPrice, setNewUnitaryPrice] = useState(null);
  const [modalEditUnitaryPrice, setModalEditUnitaryPrice] = useState(false);
  const toggleEditUnitaryPrice = () => {
    setNewUnitaryPrice(null);
    setModalEditUnitaryPrice(!modalEditUnitaryPrice);
  };

  const [inputQuant, setInputQuant] = useState(parseFloat(input.quantidade));
  const [inputZero, setInputZero] = useState(0);
  const [inputInicial, setInputInicial] = useState(
    parseFloat(input.quantidade)
  );
  const [isAverage, setIsAverage] = useState(
    input.quantidade <= 0 ? [false] : [true]
  );
  const [tooltip, setTooltip] = useState(false);
  const [inputDisabled, setInputDisabled] = useState(false);
  const [valueToSend, setValueToSend] = useState(parseFloat(input.quantidade));
  const [totalToSend, setTotalToSend] = useState(0);

  const [changeAllUnit, setChangeAllUnit] = useState(true);
  const [newUnit, setNewUnit] = useState('');
  const [valueNewUnit, setValueNewUnit] = useState(1);

  const [historyInput, setHistoryInput] = useState(null);

  const [createCashFlow, setCreateCashFlow] = useState(true);

  function handleCreateCashFlow() {
    setCreateCashFlow(!createCashFlow);
  }

  const justificatives = [
    { value: 0, label: 'Perda por validade/vencimento' },
    { value: 1, label: 'Desperdício de produção' },
    { value: 2, label: 'Item Danificado' },
    { value: 3, label: 'Devolução de mercadoria' },
    { value: -1, label: 'Outros' },
  ];

  const [selectedJustificative, setSelectedJustificative] = useState(null);

  useEffect(() => {
    if (parseFloat(valueToSend) > inputInicial) {
      setInputDisabled(false);
    } else {
      setInputDisabled(true);
    }
  }, [valueToSend, inputInicial]);

  useEffect(() => {
    if (modal) {
      setInputInicial(input.quantidade);
    }
  }, [modal]);

  const [loading, setLoading] = useState(false);

  const handleUpdateInput = useCallback(
    async (data) => {
      setLoading(true);
      try {
        let justificative = data.inputed_justificative || null;

        if (selectedJustificative?.value !== -1) {
          justificative = selectedJustificative?.label;
        }

        const new_date = data.due_date
          ? `${data.due_date}T03:00:00.000Z`
          : null;
        const new_paid = `${data.paid_at}T03:00:00.000Z`;

        const handleData = {
          id: input.id,
          quantidade: valueToSend,
          name: data.name,
          total: data.total_to_send.replace(',', '.') || 0,
          cash_flow_category_subcategory_id: data.category || null,
          minimum_stock: data.minimum_stock,
          ideal_stock: data.ideal_stock,
          provider_id: data.provider_id || null,
          bank_account_id: data.bank_account_id || null,
          due_date: new_date,
          paid: data.paid,
          paid_at: data.paid ? new_paid : null,
          justificative,
          is_average: !isAverage[0],
          create_cash_flow: inputZero >= 0 ? data.create_cashflow : false,
          cash_flow_payment_method_id: data.cash_flow_payment_method_id,
        };

        if (!data.quantidade) {
          toast.error('Coloque a quantidade do insumo.');
        } else if (
          valueToSend > parseFloat(inputInicial) &&
          !data.total_to_send
        ) {
          toast.error('Coloque o valor gasto do insumo.');
        } else if (isAverage.length < 1) {
          toast.error('Selecione um modo de calcular custo unitário.');
        } else if (valueToSend > parseFloat(inputInicial) && !data.category) {
          toast.error('Selecione um centro de custo.');
        } else {
          const response = await api.put(`/restaurants/inputs`, handleData);
          // document.getElementById('update_button').click();
          // getInputs();
          setInputInicial(valueToSend);
          setInputZero(0);
          setInputQuant(valueToSend);
          setCreateCashFlow(true);
          setSelectedJustificative(null);
          setModal(false);

          if (inputsFiltered) {
            const newInputs = [...inputsFiltered];
            const inputFind = newInputs.findIndex(
              (item) => item.id === input.id
            );

            if (inputFind !== -1) {
              newInputs[inputFind] = { ...response.data };

              setInputsFiltered(newInputs);
            }
          }
          toast.success('Insumo atualizado com sucesso!');
        }
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
      setLoading(false);
    },
    [valueToSend, selectedJustificative, isAverage, inputInicial, input.id]
  );
  const handleUpdateCashFlowCategory = useCallback(
    async (cfop, cst, category, selectCategory, selectCfopOrCst) => {
      const inputToSubmit = {
        id: input.id,
        quantidade: input.quantidade,
        name: input.name,
        minimum_stock: input.minimum_stock || '',
        ideal_stock: input.ideal_stock || '',
        is_average: input.is_average,
      };

      try {
        if (!selectCategory) {
          const handleData = {
            ...inputToSubmit,
            cash_flow_category_subcategory_id: category?.value || null,
          };
          await api.put(`/restaurants/inputs`, handleData);
        }

        if (!selectCfopOrCst) {
          let handleFiscal = {};
          if (cfop !== undefined && cst !== undefined) {
            handleFiscal = {
              cfop: cfop.value,
              cst: cst.value,
            };
          } else if (cfop !== undefined && cst === undefined) {
            handleFiscal = {
              cfop: cfop.value,
            };
          } else if (cfop === undefined && cst !== undefined) {
            handleFiscal = {
              cst: cst.value,
            };
          }
          await api.put(`/restaurants/inputs/fiscal/${input.id}`, handleFiscal);
        }

        getInputs();
        setSelectedCfop();
        setCostCenterChange(true);
        setEnableButton(true);
        toast.success('Insumo atualizado com sucesso!');
      } catch (error) {
        toast.error('Erro ao atualizar insumo.');
        setSelectCategory(selectCategoryDefault);
      }
    },
    [defaultCategory, input]
  );

  const [paidCheck, setPaidCheck] = useState(false);

  function handleSetPaidCheck() {
    setPaidCheck(!paidCheck);
  }

  const handleChangeUnit = useCallback(async () => {
    try {
      const handleData = {
        input_id: input.id,
        value: valueNewUnit,
        unit_change: newUnit,
        // unit_inicial: input.unidade,
        // change_all: changeAllUnit
      };

      if (!valueNewUnit || parseFloat(valueNewUnit) === 0) {
        toast.error('Valor de conversão deve ser válido e diferente de zero.');
      } else if (newUnit === '') {
        toast.error('Informe a nova unidade.');
      } else {
        const response = await api.put(`/restaurants/change-unit`, handleData);
        // document.getElementById('update_button').click();
        // getInputs();

        if (inputsFiltered) {
          const newInputs = [...inputsFiltered];
          const inputFind = newInputs.findIndex((item) => item.id === input.id);

          if (inputFind !== -1) {
            newInputs[inputFind] = { ...response.data };

            setInputsFiltered(newInputs);
          }
        }
        setValueNewUnit(1);
        setChangeAllUnit(true);
        setNewUnit('');
        setModalUnit(false);
        toast.success('Unidades convertidas com sucesso!');
      }
    } catch (error) {
      console.log(error);
      toast.error('Erro ao atualizar unidades.');
    }
  }, [newUnit, valueNewUnit, changeAllUnit, input.id]);

  const handleChangeUnitaryPrice = useCallback(
    async (data) => {
      try {
        if (!newUnitaryPrice) {
          toast.error('Informe o novo custo unitário');
          return;
        }

        const handleData = {
          new_unitary_price: newUnitaryPrice,
        };

        await api.put(
          `/restaurants/inputs/unitary-price/${input.id}`,
          handleData
        );
        setNewUnitaryPrice(null);
        setModalEditUnitaryPrice(false);
        getInputs();
        toast.success('Preço unitário atualizado');
      } catch (error) {
        console.log(error);
        toast.error('Erro ao atualizar preço unitário');
      }
    },
    [input.id, newUnitaryPrice]
  );

  const toggleEye = useCallback(() => {
    setModalEye(!modalEye);
    // setRangeStartDate(null);
  }, [modalEye]);

  // create banks

  const [isModalCreateBankOpen, setIsModalCreateBankOpen] = useState(false);

  const toggleModalCreateBank = useCallback(() => {
    setIsModalCreateBankOpen(!isModalCreateBankOpen);
  }, [isModalCreateBankOpen]);

  const handleBankSubmit = useCallback(
    async (data) => {
      try {
        if (formRefBank?.current) {
          formRefBank.current.setErrors({});
        }
        const schema = Yup.object().shape({
          name: Yup.string().required('Nome obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('/restaurants/cash-flows/bank-accounts', {
          name: data.name,
        });

        toast.success('Conta cadastrada com sucesso!');

        getBanks();
        toggleModalCreateBank();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          if (formRefBank?.current) {
            formRefBank.current.setErrors(errors);
          }
        } else {
          toast.error(`Erro ao cadastrar conta!`);
        }
      }
    },
    [getBanks, toggleModalCreateBank]
  );

  // create suplliers

  const [isModalCreateSuppliersOpen, setIsModalCreatesuppliersOpen] =
    useState(false);

  const toggleModalCreateSuplliers = useCallback(() => {
    setIsModalCreatesuppliersOpen(!isModalCreateSuppliersOpen);
  }, [isModalCreateSuppliersOpen]);

  const handleSupplierSubmit = useCallback(
    async (data) => {
      try {
        if (formRefSupplier?.current) {
          formRefSupplier.current.setErrors({});
        }
        const schema = Yup.object().shape({
          name: Yup.string().required('Nome obrigatório'),
          cnpj: Yup.string()
            .required('CNPJ/ CPF obrigatório')
            .trim()
            .matches('^[0-9]+$', 'Apenas números, sem espaço'),
          phone: Yup.string().required('Telefone obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('/restaurants/cash-flows/providers', {
          name: data.name,
          phone: data.phone,
          cnpj: data.cnpj,
        });

        toast.success('Fornecedor cadastrada com sucesso!');

        getSuppliers();
        toggleModalCreateSuplliers();
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          if (formRefSupplier?.current) {
            formRefSupplier.current.setErrors(errors);
          }
        } else {
          toast.error(`Erro ao cadastrar fornecedor!`);
        }
      }
    },
    [getSuppliers, toggleModalCreateSuplliers]
  );

  const inputInitialData = {
    ...input,
    quantidade: parseFloat(input?.quantidade).toFixed(4),
  };

  const getInputHistory = useCallback(
    (id, start, end) => {
      try {
        api
          .get('/restaurants/history-inputs', {
            params: {
              input_id: id || 0,
              start_date: start,
              end_date: end,
            },
          })
          .then((response) => {
            const history = response.data;
            setHistoryInput(
              history.sort((a, b) => {
                const d1 = new Date(a.createdAt).getTime();
                const d2 = new Date(b.createdAt).getTime();

                if (d1 === d2) {
                  return orderDate ? b.id - a.id : a.id - b.id;
                }

                return orderDate ? d2 - d1 : d1 - d2;
              })
            );
          })
          .catch((e) => toast.error('Não foi possível consultar o histórico.'));
      } catch (err) {
        console.log(err);
      }
    },
    [orderDate]
  );

  useEffect(() => {
    try {
      if (modalEye && rangeStartDate) {
        getInputHistory(input?.id, rangeStartDate?.start, rangeStartDate?.end);
      }
    } catch (err) {
      console.log(err);
    }
  }, [modalEye, rangeStartDate]);

  function currencyFormatter(value) {
    if (!Number(value)) return '';

    const amount = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value / 100);

    return `${amount}`;
  }

  const handleDownloadInputs = async () => {
    try {
      const sheet = await generateSpecificInputsReportSheetXLSX(
        historyInput,
        input.unidade
      );
      const uint = new Uint8Array(sheet);
      const blob = new Blob([uint], { type: 'application/excel' });

      FileSaver.saveAs(
        blob,
        `Movimentações Insumo (${input.name}) - ${
          months[getMonth(rangeStartDate.start)]
        }.xlsx`
      );
    } catch (err) {
      console.log('Error download sheet > ', err);
    }
  };

  function sortDate() {
    const history = historyInput ? historyInput.slice() : [];

    setHistoryInput(
      history.sort((a, b) => {
        const d1 = new Date(a.createdAt).getTime();
        const d2 = new Date(b.createdAt).getTime();

        return !orderDate ? d2 - d1 : d1 - d2;
      })
    );

    setOrderDate(!orderDate);
  }
  function handleCfopOption() {
    const cfopOption = cfop_options.find(
      (cfop) => cfop.value.toString() === input.cfop
    );
    return cfopOption;
  }

  function handleCstOption() {
    const cstOption = icms_origem_options.find(
      (cst) => cst.value.toString() === input.cst
    );
    return cstOption;
  }

  return (
    <>
      <tr>
        <td>
          {input.name} ({input.unidade})
        </td>

        {isInventory ? (
          <td>
            <input
              defaultValue={parseFloat(input.quantidade)}
              value={inventory[input.id]}
              onChange={(e) =>
                setInventory({ ...inventory, [input.id]: e.target.value })
              }
              style={{ width: '75px', textAlign: 'center' }}
            />
          </td>
        ) : parseFloat(input.quantidade) > 0 ? (
          <td>
            <strong style={{ color: 'green' }}>
              {parseFloat(input.quantidade).toFixed(4).replace('.', ',')}{' '}
              {input.unidade.toUpperCase()}
            </strong>
            {user?.allow_inputs && (
              <button
                style={{
                  border: 'none',
                  borderRadius: '50%',
                  width: 20,
                  height: 20,
                  background: 'orange',
                  marginLeft: 5,
                }}
                onClick={() => toggleUnit()}
              >
                <RiArrowLeftRightLine size={10} color="white" />
              </button>
            )}
          </td>
        ) : (
          <td>
            <strong style={{ color: 'red' }}>
              {parseFloat(input.quantidade).toFixed(4).replace('.', ',')}{' '}
              {input.unidade.toUpperCase()}
            </strong>
            {user?.allow_inputs && (
              <button
                style={{
                  border: 'none',
                  borderRadius: '50%',
                  width: 20,
                  height: 20,
                  background: 'orange',
                  marginLeft: 5,
                }}
                onClick={() => toggleUnit()}
                type="button"
              >
                <RiArrowLeftRightLine size={10} color="white" />
              </button>
            )}
          </td>
        )}
        <td>
          R$
          {parseFloat(input.unitary_price).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
          })}
          <button
            style={{
              border: 'none',
              width: 20,
              height: 20,
              background: 'transparent',
              marginLeft: 2,
            }}
            type="button"
            onClick={() => toggleEditUnitaryPrice()}
          >
            <MdEdit size={15} color="#17a2b8" />
          </button>
        </td>
        <td>
          {parseFloat(input.quantidade) >= 0
            ? `R$${parseFloat(input.total_value).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })}`
            : 'N/A'}
        </td>
        <td>
          <div style={{ display: 'flex' }}>
            <StyledSelect
              name="category"
              options={categories}
              value={selectCategory}
              placeholder="Selecione a categoria"
              onChange={(e) => {
                setSelectCategory(e);
                setCostCenterChange(false);
              }}
              isDisabled={input?.is_multistore_child}
            />
            {user?.regime_tributario === '1' && (
              <NewButton
                icon={<FaCheck />}
                onClick={() => {
                  handleUpdateCashFlowCategory(
                    selectedCfop,
                    selectedCst,
                    selectCategory,
                    costCenterChange,
                    enableButton
                  );
                }}
                disabled={
                  input?.is_multistore_child ||
                  (costCenterChange && enableButton)
                }
                style={{ borderRadius: 12, width: 40, marginLeft: 8 }}
                customColor="#2EC9B7"
              />
            )}
          </div>
        </td>
        {user?.regime_tributario === '2' && (
          <>
            <td>
              {/* aquii */}
              <StyledSelect
                options={cfop_options}
                value={selectedCfop}
                onChange={(e) => {
                  setSelectedCfop(e);
                  setEnableButton(false);
                }}
                isDisabled={input?.is_multistore_child}
              />
            </td>
            <td>
              <div style={{ display: 'flex' }}>
                <StyledSelect
                  options={icms_origem_options}
                  value={selectedCst}
                  onChange={(e) => {
                    setSelectedCst(e);
                    setEnableButton(false);
                  }}
                  containerStyles={{ marginRight: 8 }}
                  isDisabled={input?.is_multistore_child}
                />
                <NewButton
                  icon={<FaCheck />}
                  onClick={() => {
                    handleUpdateCashFlowCategory(
                      selectedCfop,
                      selectedCst,
                      selectCategory,
                      costCenterChange,
                      enableButton
                    );
                  }}
                  disabled={
                    input?.is_multistore_child ||
                    (costCenterChange && enableButton)
                  }
                  style={{ borderRadius: 12, width: 40, marginLeft: 8 }}
                  customColor="#2EC9B7"
                />
              </div>
            </td>
          </>
        )}
        <td style={{ width: 100 }}>
          <Actions>
            {!input.is_master && (
              <>
                <Delete onClick={toggle} disabled={input.is_master}>
                  <IconPencilFilled fontSize={20} fill="#17a2b8" />
                </Delete>
              </>
            )}
            <Delete onClick={toggleEye}>
              <IconEyeFilled fontSize={20} fill="#01AFFF" />
            </Delete>
            {!input?.is_multistore_child && !input.is_master && (
              <Delete
                onClick={() => handleDelete(input.id, filterString)}
                disabled={input.is_master}
              >
                <IconTrashFilled fontSize={20} fill="#C8131B" />
              </Delete>
            )}
          </Actions>

          <Modal
            isOpen={isModalCreateSuppliersOpen}
            toggle={toggleModalCreateSuplliers}
          >
            <ModalHeader> Criar Fornecedor</ModalHeader>
            <Form onSubmit={handleSupplierSubmit} ref={formRefSupplier}>
              <ModalBody>
                <Input label="Nome do fornecedor" name="name" />
                <Input label="CNPJ" name="cnpj" />
                <ReactInputMask mask="(99) 99999-9999">
                  <Input
                    label="Telefone"
                    name="phone"
                    maskChar=""
                    placeholder="(xx) xxxxx-xxxx"
                  />
                </ReactInputMask>
              </ModalBody>
              <ModalFooter>
                <Button
                  onClick={toggleModalCreateSuplliers}
                  title="Cancelar"
                  type="button"
                />
                <Button
                  buttonColor="#2EC9B7"
                  type="submit"
                  title="Salvar"
                  onClick={() => {}}
                />
              </ModalFooter>
            </Form>
          </Modal>

          <Modal isOpen={isModalCreateBankOpen} toggle={toggleModalCreateBank}>
            <ModalHeader> Criar Conta</ModalHeader>
            <Form onSubmit={handleBankSubmit} ref={formRefBank}>
              <ModalBody>
                <Input label="Nome do banco" name="name" />
              </ModalBody>
              <ModalFooter>
                <Button
                  onClick={toggleModalCreateBank}
                  title="Cancelar"
                  type="button"
                />
                <Button
                  buttonColor="#2EC9B7"
                  type="submit"
                  title="Salvar"
                  onClick={() => {}}
                />
              </ModalFooter>
            </Form>
          </Modal>

          <Modal isOpen={modal} toggle={toggle}>
            <Form onSubmit={handleUpdateInput} initialData={inputInitialData}>
              <ModalHeader>Editar Insumos</ModalHeader>
              <ModalBody>
                <Container>
                  <Row>
                    <Col>
                      <Input
                        label="Nome do Insumo"
                        name="name"
                        type="text"
                        disabled={input?.is_multistore_child || false}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <InputAreaStyled>
                        <b>Qtd. Disponível</b>
                        <Input
                          name="quantidade"
                          type="number"
                          step="0.001"
                          disabled
                        />
                      </InputAreaStyled>
                    </Col>
                    <Col md="4">
                      <InputAreaStyled>
                        <b>Custo Unitário Atual</b>
                        <Input
                          name="unitary_price"
                          type="number"
                          step=".01"
                          disabled
                        />
                      </InputAreaStyled>
                    </Col>
                    <Col md="4">
                      <InputAreaStyled>
                        <b>Valor em Estoque</b>
                        <Input
                          name="total_value"
                          type="number"
                          step=".001"
                          disabled
                        />
                      </InputAreaStyled>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4" style={{ marginLeft: 10 }}>
                      <Row>
                        <Col md="1">
                          <button
                            type="button"
                            style={{
                              width: 32,
                              height: 32,
                              position: 'absolute',
                              bottom: 0,
                              left: 10,
                              background: '#FF3939',
                              borderRadius: '50%',
                              border: 'none',
                              marginBottom: 15,
                            }}
                            onClick={() => {
                              setInputQuant(parseFloat(inputQuant) - 1);
                              setInputZero(parseFloat(inputZero) - 1);
                              setValueToSend(
                                Number(inputInicial) + parseFloat(inputZero) - 1
                              );
                            }}
                          >
                            -
                          </button>
                        </Col>
                        <Col md="9">
                          <Input
                            label="Quantidade"
                            name="quantidade"
                            type="number"
                            step="0.01"
                            value={inputZero}
                            onChange={(e) => {
                              setInputZero(e.target.value);
                              setValueToSend(
                                Number(inputInicial) +
                                  parseFloat(e.target.value)
                              );
                            }}
                          />
                        </Col>

                        <Col md="1">
                          <button
                            type="button"
                            style={{
                              width: 32,
                              height: 32,
                              position: 'absolute',
                              bottom: 0,
                              left: 132,
                              background: '#3BD2C1',
                              borderRadius: '50%',
                              border: 'none',
                              marginBottom: 15,
                            }}
                            onClick={() => {
                              setInputQuant(parseFloat(inputQuant) + 1);
                              setInputZero(parseFloat(inputZero) + 1);
                              setValueToSend(
                                Number(inputInicial) + parseFloat(inputZero) + 1
                              );
                            }}
                          >
                            +
                          </button>
                        </Col>
                      </Row>
                    </Col>
                    <Col md="4" style={{ marginLeft: 15 }}>
                      <Input
                        label="Valor Gasto"
                        name="total_to_send"
                        type="number"
                        step="0.01"
                        value={totalToSend}
                        onChange={(e) => setTotalToSend(e.target.value)}
                        disabled={inputDisabled}
                        id="input"
                      />
                    </Col>
                    <Col md="3">
                      <Row>
                        <p
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginTop: 10,
                          }}
                        >
                          <strong>Nova Qtd.</strong>{' '}
                          <span>
                            {isNaN(Number(inputInicial) + Number(inputZero))
                              ? Number(inputInicial).toFixed(4)
                              : (
                                  Number(inputInicial) + Number(inputZero)
                                ).toFixed(4)}
                          </span>
                        </p>
                      </Row>
                    </Col>
                  </Row>
                  {inputInicial + parseFloat(inputZero) > 0 &&
                    inputZero >= 0 && (
                      <Row>
                        <p style={{ fontWeight: 'bold' }}>
                          Qual custo unitário usar?{' '}
                          <FaQuestionCircle
                            color="orange"
                            onMouseEnter={() => setTooltip(true)}
                            onMouseLeave={() => setTooltip(false)}
                          />
                        </p>
                        <CheckboxGroup
                          name="average"
                          value={isAverage}
                          onChange={(e) => {
                            setIsAverage((state) => {
                              if (e.length < 1) {
                                return [];
                              }
                              return e.filter((i) => !state.includes(i));
                            });
                          }}
                        >
                          {(Checkbox) => (
                            <div
                              style={{
                                display: 'flex',
                              }}
                            >
                              <label
                                style={{
                                  marginRight: '20px',
                                }}
                              >
                                <Checkbox value /> Novo (R$
                                {(inputZero === 0 ||
                                isNaN(
                                  parseFloat(totalToSend) /
                                    parseFloat(inputZero)
                                )
                                  ? 0
                                  : parseFloat(totalToSend) /
                                    parseFloat(inputZero)
                                ).toFixed(2)}
                                )
                              </label>
                              {input.quantidade > 0 && (
                                <label
                                  title={
                                    input.quantidade <= 0
                                      ? 'A quantidade atual deste insumo no estoque é menor que zero, portanto não podemos calcular uma média ponderada.'
                                      : undefined
                                  }
                                >
                                  <Checkbox
                                    value={false}
                                    disabled={input.quantidade <= 0}
                                  />{' '}
                                  Média ponderada (R$
                                  {(
                                    0 +
                                    (parseFloat(totalToSend) +
                                      parseFloat(input.total_value)) /
                                      (parseFloat(inputZero) +
                                        parseFloat(input.quantidade))
                                  ).toFixed(2)}
                                  )
                                </label>
                              )}
                            </div>
                          )}
                        </CheckboxGroup>
                      </Row>
                    )}
                  {inputZero && inputZero < 0 ? (
                    <Row>
                      <Col>
                        <ReactSelect
                          placeholder="Selecione a justificativa"
                          options={justificatives}
                          onChange={(e) => {
                            setSelectedJustificative(e);
                          }}
                          value={selectedJustificative}
                          name="justificative"
                        />
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}

                  {selectedJustificative && selectedJustificative.value < 0 ? (
                    <Row>
                      <Col>
                        <Input
                          placeholder="Escreva a justificativa"
                          name="inputed_justificative"
                          type="text"
                          id="input"
                        />
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                  <Row>
                    <Col md="6">
                      <Input
                        label="Estoque Mínimo"
                        name="minimum_stock"
                        type="number"
                        step="0.001"
                      />
                    </Col>
                    <Col md="6">
                      <Input
                        label="Estoque Ideal"
                        name="ideal_stock"
                        type="number"
                        step="0.001"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Select
                        label="Associar Centro de Custo"
                        name="category"
                        options={categories}
                        placeholder="Selecione"
                        defaultValue={selectCategory}
                        disabled={input?.is_multistore_child || false}
                        // onChange={(e) => setInputSelectedId(e.value)}
                      />
                    </Col>
                  </Row>

                  {inputZero >= 0 && (
                    <>
                      <p style={{ marginTop: 10 }}>
                        Informações Adicionais{' '}
                        <FaQuestionCircle
                          color="orange"
                          title="Complemente as informações do seu lançamento para uma melhor gestão de estoque."
                        />
                      </p>

                      <Row>
                        <div
                          style={{
                            display: 'flex',
                          }}
                        >
                          <label>
                            <CheckboxInput
                              name="create_cashflow"
                              label="Vincular esta movimentação ao financeiro"
                              defaultChecked
                              onChange={() => {
                                handleCreateCashFlow();
                              }}
                            />
                          </label>
                        </div>
                      </Row>
                    </>
                  )}

                  {createCashFlow && inputZero >= 0 && (
                    <div>
                      <Row>
                        <Col>
                          <Row>
                            <Col md="10">
                              <Select
                                label="Fornecedor"
                                name="provider_id"
                                options={suppliers}
                                placeholder="Fornecedor"
                                // onChange={(e) => setInputSelectedId(e.value)}
                              />
                            </Col>
                            <Col md="1">
                              <button
                                type="button"
                                style={{
                                  width: 32,
                                  height: 32,
                                  position: 'absolute',
                                  bottom: 0,
                                  left: 0,
                                  background: '#3BD2C1',
                                  borderRadius: '50%',
                                  border: 'none',
                                  marginBottom: 15,
                                }}
                                title="Cadastrar Fornecedor"
                                onClick={toggleModalCreateSuplliers}
                              >
                                +
                              </button>
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <Row>
                            <Col md="10">
                              <Select
                                label="Conta"
                                name="bank_account_id"
                                options={banks}
                                placeholder="Conta"
                                // onChange={(e) => setInputSelectedId(e.value)}
                              />
                            </Col>
                            <Col md="1">
                              <button
                                type="button"
                                style={{
                                  width: 32,
                                  height: 32,
                                  position: 'absolute',
                                  bottom: 0,
                                  left: 0,
                                  background: '#3BD2C1',
                                  borderRadius: '50%',
                                  border: 'none',
                                  marginBottom: 15,
                                }}
                                onClick={toggleModalCreateBank}
                                title="Cadastrar Conta Bancária"
                              >
                                +
                              </button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      <Row>
                        <Input
                          id="date-local"
                          label="Vencimento"
                          type="date"
                          name="due_date"
                          defaultValue={format(new Date(), 'yyyy-MM-dd')}
                          className="data"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Row>
                      <Row>
                        <Col>
                          <CheckboxInput
                            name="paid"
                            label="Pago"
                            checked={paidCheck}
                            onChange={handleSetPaidCheck}
                          />
                        </Col>{' '}
                      </Row>

                      {paidCheck && (
                        <>
                          <Row>
                            <Col>
                              <Input
                                id="date-local"
                                label="Pago em:"
                                type="date"
                                name="paid_at"
                                defaultValue={format(new Date(), 'yyyy-MM-dd')}
                                className="data"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Select
                              placeholder="Método de pagamento"
                              options={paymentMethods}
                              name="cash_flow_payment_method_id"
                            />
                          </Row>
                        </>
                      )}
                    </div>
                  )}
                </Container>

                <StyledTooltip show={tooltip}>
                  <p>
                    <span style={{ fontWeight: 'bold' }}>Média ponderada:</span>{' '}
                    Faz uma média ponderada entre seu estoque e o insumo que
                    você está dando entrada.
                  </p>
                  <p>
                    <span style={{ fontWeight: 'bold' }}>Atual:</span> Atualiza
                    o custo do estoque com base apenas no insumo que você está
                    dando entrada.
                  </p>
                </StyledTooltip>
              </ModalBody>
              <ModalFooter>
                <Button onClick={toggle} title="Cancelar" type="button" />
                <Button
                  buttonColor="#2EC9B7"
                  type="submit"
                  title="Salvar"
                  onClick={() => {}}
                  disabled={loading}
                />
              </ModalFooter>
            </Form>
          </Modal>

          <Modal isOpen={modalEye} toggle={toggleEye} size="xl">
            {/* <ModalHeader>Histórico do Insumo</ModalHeader> */}
            <ModalBody>
              <Container>
                <Row style={{ alignItems: 'center' }}>
                  {/* <div style={{ padding: '0px 5px' }}>
                    <InformationDiv
                      type="warning"
                      text={
                        <p>
                          O estoque é atualizado automaticamente{' '}
                          <b> uma vez ao dia </b> às <b> 03:00h. </b> Faça a
                          atualização manual clicando em{' '}
                          <b>“ATUALIZAR AGORA”</b>
                        </p>
                      }
                    />
                  </div> */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      padding: '16px 8px',
                    }}
                  >
                    <div
                      style={{ display: 'flex', gap: 10, alignItems: 'center' }}
                    >
                      <DownloadButton
                        onClick={() => {
                          if (historyInput.length > 0) {
                            handleDownloadInputs();
                          } else {
                            toast.error('Não há movimentações nesse período.');
                          }
                        }}
                      />
                      {/* <MonthCalendar onDateSelected={setMonthYearDate} /> */}
                      <FullCalendar
                        isRange
                        onDateSelected={setRangeStartDate}
                        value={rangeStartDate}
                        hideFields={['this_year']}
                      />
                    </div>
                  </div>
                  <Col md="9">
                    Histórico do Insumo: <b>{input.name}</b>
                  </Col>

                  <Col md="3">
                    <div
                      style={{
                        marginBottom: 15,
                        float: 'right',
                        display: 'flex',
                      }}
                    />
                  </Col>
                </Row>

                <HistoryTable>
                  <thead>
                    <tr>
                      <th
                        style={{ cursor: 'pointer' }}
                        onClick={() => sortDate()}
                      >
                        <FiArrowDown />
                        Data / Hora
                      </th>
                      <th>Saldo Inicial ({input.unidade})</th>
                      <th>Variação</th>
                      <th>Saldo Final ({input.unidade})</th>
                      <th>Valor</th>
                      <th>Custo unitário</th>
                      <th>Operação</th>
                      <th>Usuário</th>
                      <th>Justificativa</th>
                    </tr>
                  </thead>
                  <tbody>
                    {historyInput?.map((history) =>
                      history.type === '+' ? (
                        <tr style={{ background: '#D7EED2', color: '#1E3422' }}>
                          <td>{formatCompleteDate(history.createdAt)}</td>
                          <td>
                            {history.balance && !isNaN(history.balance)
                              ? `${(
                                  parseFloat(history.balance) -
                                  parseFloat(history.quantidade)
                                ).toLocaleString('pt-BR', {
                                  minimumFractionDigits: 4,
                                  maximumFractionDigits: 4,
                                })}`
                              : '-'}
                          </td>
                          <td>
                            {history.type}{' '}
                            {parseFloat(history.quantidade)
                              .toFixed(4)
                              .replace('.', ',')}
                          </td>
                          <td>
                            {history.balance && !isNaN(history.balance)
                              ? `${parseFloat(history.balance).toLocaleString(
                                  'pt-BR',
                                  {
                                    minimumFractionDigits: 4,
                                    maximumFractionDigits: 4,
                                  }
                                )}`
                              : '-'}
                          </td>
                          <td>
                            {history.total && !isNaN(history.total)
                              ? `R$${parseFloat(history.total).toLocaleString(
                                  'pt-BR',
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}`
                              : history.unitary_price &&
                                !isNaN(history.unitary_price) &&
                                history.quantidade &&
                                !isNaN(history.quantidade) &&
                                parseFloat(history.quantidade) > 0 &&
                                `R$${(
                                  parseFloat(history.quantidade) *
                                  parseFloat(history.unitary_price)
                                ).toLocaleString('pt-BR', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}`}
                          </td>

                          <td>
                            {history.unitary_price &&
                            !isNaN(history.unitary_price)
                              ? `R$${parseFloat(
                                  history.unitary_price
                                ).toLocaleString('pt-BR', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}`
                              : '-'}
                          </td>

                          <td>
                            {history.product && `[P] ${history.product.name}`}
                            {history.complement &&
                              `[C] ${history.complement.name}`}
                            {history.intermediary &&
                              `[PI] ${history.intermediary.name}`}
                            {history.intermediary &&
                              history.operation === 'intermediary_deleted' &&
                              ` - Deletado`}
                            {!history.complement &&
                              !history.product &&
                              !history.intermediary &&
                              (history.operation !== 'nfe'
                                ? 'Editado Manualmente'
                                : 'Entrada de Nota Fiscal')}
                          </td>
                          <td>{history.user ? history.user.name : '-'}</td>
                          <td>
                            {history.justificative
                              ? history.justificative
                              : !history.nfe && '-'}
                            {history.nfe &&
                              `Fornecedor: ${history.nfe?.provider || '-'}`}
                          </td>
                        </tr>
                      ) : (
                        <tr style={{ background: '#FBD1C5', color: '#590D12' }}>
                          <td>{formatCompleteDate(history.createdAt)}</td>
                          <td>
                            {history.balance && !isNaN(history.balance)
                              ? `${(
                                  parseFloat(history.balance) +
                                  parseFloat(history.quantidade)
                                ).toLocaleString('pt-BR', {
                                  minimumFractionDigits: 4,
                                  maximumFractionDigits: 4,
                                })}`
                              : '-'}
                          </td>
                          <td>
                            {history.type}{' '}
                            {parseFloat(history.quantidade)
                              .toFixed(4)
                              .replace('.', ',')}
                          </td>
                          <td>
                            {history.balance && !isNaN(history.balance)
                              ? `${parseFloat(history.balance).toLocaleString(
                                  'pt-BR',
                                  {
                                    minimumFractionDigits: 4,
                                    maximumFractionDigits: 4,
                                  }
                                )}`
                              : '-'}
                          </td>
                          <td>
                            {history.total && !isNaN(history.total)
                              ? `R$${parseFloat(history.total).toLocaleString(
                                  'pt-BR',
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}`
                              : '-'}
                          </td>

                          <td>
                            {history.unitary_price &&
                            !isNaN(history.unitary_price)
                              ? `R$${parseFloat(
                                  history.unitary_price
                                ).toLocaleString('pt-BR', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}`
                              : '-'}
                          </td>

                          <td>
                            {history.product && `[P] ${history.product.name}`}
                            {history.complement &&
                              `[C] ${history.complement.name}`}
                            {history.intermediary &&
                              `[PI] ${history.intermediary.name}`}
                            {history.intermediary &&
                              history.operation === 'intermediary_deleted' &&
                              ` - Deletado`}
                            {!history.complement &&
                              !history.product &&
                              !history.intermediary &&
                              (history.operation !== 'nfe'
                                ? 'Editado Manualmente'
                                : 'Entrada de Nota Fiscal')}
                          </td>

                          <td>{history.user ? history.user.name : '-'}</td>

                          <td>
                            {history.justificative
                              ? history.justificative
                              : !history.nfe && '-'}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </HistoryTable>
              </Container>
            </ModalBody>
            <ModalFooter>
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Button
                  onClick={toggleEye}
                  title="Fechar"
                  type="button"
                  buttonColor="#C8131B"
                  containerStyles={{ borderRadius: 12 }}
                />
              </div>
            </ModalFooter>
          </Modal>

          <Modal isOpen={modalUnit} toggle={toggleUnit}>
            <ModalHeader>Converter Unidade</ModalHeader>
            <ModalBody>
              <Container>
                <Form>
                  <Row>
                    <Col md="4" style={{ margin: 'auto' }}>
                      1 {input.unidade} equivale a:
                    </Col>
                    <Col md="4">
                      <Input
                        type="number"
                        step="0.1"
                        label="Valor"
                        name="value_change"
                        id="value_change"
                        value={valueNewUnit}
                        placeholder="Valor de conversão"
                        onChange={(e) => setValueNewUnit(e.target.value)}
                      />
                    </Col>
                    <Col md="4">
                      <Input
                        type="text"
                        name="unit_change"
                        placeholder="ex: KG"
                        label="Unidade"
                        value={newUnit}
                        onChange={(e) => setNewUnit(e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <strong>Atualizado: </strong> {input.quantidade}{' '}
                      {input.unidade} {'=>'}{' '}
                      {(parseFloat(input.quantidade) * valueNewUnit)
                        .toFixed(3)
                        .replace('.', ',')}{' '}
                      {newUnit || 'nova unidade'}
                    </Col>
                  </Row>
                </Form>
              </Container>
            </ModalBody>
            <ModalFooter>
              <Button onClick={toggleUnit} title="Fechar" type="button" />
              <Button
                buttonColor="#2EC9B7"
                type="submit"
                title="Converter"
                onClick={() => handleChangeUnit()}
              />
            </ModalFooter>
          </Modal>

          <Modal
            isOpen={modalEditUnitaryPrice}
            toggle={toggleEditUnitaryPrice}
            size="sm"
          >
            <ModalBody>
              <Container>
                <Form onSubmit={handleChangeUnitaryPrice}>
                  <Row style={{ marginTop: 0 }}>
                    <Col>
                      <InputCurrency
                        name="new_unitary_price"
                        label="Novo custo unitário"
                        type="text"
                        prefix="R$"
                        placeholder="R$"
                        format={currencyFormatter}
                        onValueChange={(e) => {
                          setNewUnitaryPrice(
                            e.floatValue > 0 ? e.floatValue / 100 : null
                          );
                        }}
                      />
                    </Col>
                  </Row>
                </Form>
              </Container>
            </ModalBody>
            <ModalFooter>
              <Button
                onClick={toggleEditUnitaryPrice}
                title="Fechar"
                type="button"
              />
              <Button
                buttonColor="#2EC9B7"
                type="button"
                title="Salvar"
                onClick={handleChangeUnitaryPrice}
              />
            </ModalFooter>
          </Modal>
        </td>
      </tr>
    </>
  );
});

export default InputRow;
